"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _LazyValueStore = require("crm_data/store/LazyValueStore");

var _TicketsPipelinesAPI = require("crm_data/tickets/api/TicketsPipelinesAPI");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  fetch: _TicketsPipelinesAPI.fetch,
  namespace: _ActionNamespaces.TICKET_PIPELINES
}).defineResponseTo(_ActionTypes.TICKET_PIPELINES_CREATE_SUCCEEDED, function (state, newPipeline) {
  return state.setIn(['value', newPipeline.get('pipelineId')], newPipeline);
}).defineResponseTo(_ActionTypes.TICKET_PIPELINES_UPDATE_SUCCEEDED, function (state, updated) {
  return state.setIn(['value', updated.get('pipelineId')], updated);
}).defineResponseTo(_ActionTypes.TICKET_PIPELINES_DELETE_SUCCEEDED, function (state, pipelineId) {
  return state.deleteIn(['value', pipelineId]);
}).defineResponseTo(_ActionTypes.TICKET_PIPELINES_REORDER_SUCCEEDED, function (state, pipelines) {
  var updatedPipelines = pipelines.reduce(function (map, pipeline) {
    return map.set(pipeline.get('pipelineId'), pipeline);
  }, (0, _immutable.OrderedMap)());
  return state.set('value', updatedPipelines);
}).defineName('TicketsPipelinesStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;